module.exports = __webpack_public_path__ + "static/img/qrcode.b9c3112c.png";